import { useMemo } from "react";
import { DataTable } from "@/components/ui/data-table";
import type { Invoice } from "@/lib/invoice.api";
import { createInvoiceColumns } from "../invoiceTableColumns";

interface InvoicesTableProps {
  invoices: Invoice[];
  onSelect: (invoice: Invoice) => void;
}

export function InvoicesTable({ invoices, onSelect }: InvoicesTableProps) {
  const columns = useMemo(() => createInvoiceColumns(onSelect), [onSelect]);

  return (
    <DataTable
      columns={columns}
      data={invoices}
      emptyMessage="Aucune facture."
      onRowClick={onSelect}
      pageSize={10}
    />
  );
}
